import { Footer, Link } from '@efast_public/fjd-component-library';
import logo from '../assets/fjd_logo.svg';

interface FooterLink {
  label: string;
  to: string;
}

const links: FooterLink[] = [
  { label: 'Kontakt', to: '/contact' },
  { label: 'Impressum', to: '/imprint' },
  { label: 'Datenschutz', to: '/dataprotection' },
  { label: 'Nutzungsbedingungen', to: '/termsofuse' }
];

export default function ODMFooter() {
  const version = `(${process.env.REACT_APP_BUILD_VERSION || 'local'})`;

  return (
    <Footer
      before={<img alt="Logo Fjd" src={logo} />}
      //Temporary fix for footer
      after={<div>{version}</div>}
      // style={{ position: 'fixed', bottom: '0', background: '#EFF0F3' }}
    >
      {links.map((link) => (
        <Link key={link.to} href={link.to}>
          {link.label}
        </Link>
      ))}
    </Footer>
  );
}
